/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbAcquisProfessionnelGridDto
 */
export interface FcbAcquisProfessionnelGridDto {
    /**
     * 
     * @type {number}
     * @memberof FcbAcquisProfessionnelGridDto
     */
    idacquisProfessionnel?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbAcquisProfessionnelGridDto
     */
    idapprenant?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbAcquisProfessionnelGridDto
     */
    entreprise?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbAcquisProfessionnelGridDto
     */
    adresse?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbAcquisProfessionnelGridDto
     */
    codePostal?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbAcquisProfessionnelGridDto
     */
    localite?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof FcbAcquisProfessionnelGridDto
     */
    dateDebut?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof FcbAcquisProfessionnelGridDto
     */
    dateFin?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof FcbAcquisProfessionnelGridDto
     */
    libelle?: string | null;
}

/**
 * Check if a given object implements the FcbAcquisProfessionnelGridDto interface.
 */
export function instanceOfFcbAcquisProfessionnelGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbAcquisProfessionnelGridDtoFromJSON(json: any): FcbAcquisProfessionnelGridDto {
    return FcbAcquisProfessionnelGridDtoFromJSONTyped(json, false);
}

export function FcbAcquisProfessionnelGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbAcquisProfessionnelGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idacquisProfessionnel': !exists(json, 'idacquisProfessionnel') ? undefined : json['idacquisProfessionnel'],
        'idapprenant': !exists(json, 'idapprenant') ? undefined : json['idapprenant'],
        'entreprise': !exists(json, 'entreprise') ? undefined : json['entreprise'],
        'adresse': !exists(json, 'adresse') ? undefined : json['adresse'],
        'codePostal': !exists(json, 'codePostal') ? undefined : json['codePostal'],
        'localite': !exists(json, 'localite') ? undefined : json['localite'],
        'dateDebut': !exists(json, 'dateDebut') ? undefined : (json['dateDebut'] === null ? null : new Date(json['dateDebut'])),
        'dateFin': !exists(json, 'dateFin') ? undefined : (json['dateFin'] === null ? null : new Date(json['dateFin'])),
        'libelle': !exists(json, 'libelle') ? undefined : json['libelle'],
    };
}

export function FcbAcquisProfessionnelGridDtoToJSON(value?: FcbAcquisProfessionnelGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idacquisProfessionnel': value.idacquisProfessionnel,
        'idapprenant': value.idapprenant,
        'entreprise': value.entreprise,
        'adresse': value.adresse,
        'codePostal': value.codePostal,
        'localite': value.localite,
        'dateDebut': value.dateDebut === undefined ? undefined : (value.dateDebut === null ? null : value.dateDebut.toISOString()),
        'dateFin': value.dateFin === undefined ? undefined : (value.dateFin === null ? null : value.dateFin.toISOString()),
        'libelle': value.libelle,
    };
}

